// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import {
  updateInterferenceAnalysisState,
} from 'redux/modules/interferenceAnalysis'

const togglePathHighlight = pathId => (dispatch, getState) => {
  const prevHighlighted = getState().interferenceAnalysis.get('highlightedPathIds')

  // look for the index of this segmentEndId in the current list of highlightedPaths
  const indexInSelected = prevHighlighted.indexOf(pathId)

  // if the segmentEndId wasn't in the list, then add it
  // otherwise remove the thing
  const highlightedPathIds = (
    !~indexInSelected
      ? prevHighlighted.push(pathId)
      : prevHighlighted.delete(indexInSelected)
  )

  dispatch(updateInterferenceAnalysisState({ highlightedPathIds }))
}

export default togglePathHighlight
